import { GetDateFromString } from "../../../../shared/scripts/date-functions";


export class Participant {
    SubjectId: string;

    StudyID: number;
    SiteNumber: number;

    Randomized: number;
    Consented: number;
    ScreenFail: number;

    SexId: number;
    RaceId: number;
    AgeId: number;
    Hispanic: number;
    HispanicNonWhite: number;
    HispanicId: number;
    NonWhiteHispanic: number;


    RandomizedDate: string;
    ConsentedDate: string;

    DateRandomized: Date;
    DateConsented: Date;
    MonthRandomized: Date;
    MonthConsented: Date;
    WeekRandomized: Date;
    WeekConsented: Date;


    initialize(): void {
        if (this.ConsentedDate != undefined) {
            this.DateConsented = GetDateFromString(this.ConsentedDate, 'hyphens-year-month-day');
            this.WeekConsented = GetDateFromString(this.ConsentedDate, 'hyphens-year-month-day');
            this.WeekConsented = new Date(this.WeekConsented);
            this.MonthConsented = new Date(this.DateConsented);
            this.MonthConsented.setDate(1);

            while (this.WeekConsented.getDay() != 6) { this.WeekConsented.setDate(this.WeekConsented.getDate() - 1) }
        }
        else { this.MonthConsented = undefined; }

        if (this.RandomizedDate != undefined) {
            this.DateRandomized = GetDateFromString(this.RandomizedDate, 'hyphens-year-month-day');
            this.WeekRandomized = GetDateFromString(this.RandomizedDate, 'hyphens-year-month-day');
            this.WeekRandomized = new Date(this.WeekRandomized);
            this.MonthRandomized = new Date(this.DateRandomized);
            this.MonthRandomized.setDate(1);

            while (this.WeekRandomized.getDay() != 6) { this.WeekRandomized.setDate(this.WeekRandomized.getDate() - 1) }
        }


        if (this.Hispanic == undefined)
            this.HispanicId = 2 //unknown
        else
            this.HispanicId = this.Hispanic;

            
        if (this.HispanicNonWhite == undefined)
            this.NonWhiteHispanic = 2 //unknown
        else
            this.NonWhiteHispanic = this.HispanicNonWhite
    }
}


export class AggregatedParticipants {
    Count: number;

    Race: number[];
    Hispanic: number[];
    NonWhiteHispanic: number[];
    Sex: number[];
    Age: number[];

    ClusterRVLC: number;

    aggregate(participants: Participant[]) {
        this.Count = 0;

        this.Race = [0, 0, 0, 0, 0, 0, 0, 0, 0]; //0: Multiple, 1: AIAN, 2: Asian, 3: Black, 4: MENA, 5: NHPI, 6: White, 7: Unknown, 8: Other
        this.Hispanic = [0, 0, 0]; //0: no, 1: yes, 2: unknown
        this.NonWhiteHispanic = [0, 0, 0]; //0: no, 1: yes, 2: unknown
        this.Sex = [0, 0, 0, 0, 0]; //0: female, 1: male, 2: intersex, 3: prefer not to answer, 4: unknown
        this.Age = [0, 0, 0, 0, 0]; //0: 18-30; 1: 31-50; 2: 51-70; 3: +70; 4: unknown

        this.ClusterRVLC = 0;



        participants.forEach((p: Participant) => {


            this.Count += 1;

            this.Race[p.RaceId] += 1;
            this.Hispanic[p.HispanicId] += 1;
            this.NonWhiteHispanic[p.NonWhiteHispanic] += 1;
            this.Sex[p.SexId] += 1;
            this.Age[p.AgeId] += 1; 

            switch (p.StudyID) {
                case (1): this.ClusterRVLC += 1;
                    break;
            }
        });
    }
}